import React from 'react';
import cn from 'classnames';
import type { IInitConfig, IVariant } from 'base/interfaces/product';
import styles from './index.module.less';
import Iconfont from '@base/lib/Iconfont';
import Link from '@base/lib/ThemeLink';
import BundleDealsTag from '@base/snippets/Tags/BundleDealsTag';
import ReplaceAllText from '@base/snippets/ReplaceAllText';
import { useStore, observer } from 'base/store';

type IProps = {
    shownVariant?: IVariant;
    className?: string;
}

const ProdBundleDeals: React.FC<IProps> = (props) => {
    const { userStore } = useStore();
    if (userStore.isDealer()) {
        return null;
    }
    const {
        shownVariant, className
    } = props

    const {
        bundleDealsVo
    } = shownVariant || {}

    const {
        bundleDeals,
        description,
        bundleDealsLink
    } = bundleDealsVo || {}

    return !bundleDeals ? null : (
        <Link href={bundleDealsLink || 'javascript:void(0)'}>
            <a target="_blank" rel="noopener">
                <div className={cn('flex flex-middle', className, styles['bundle-deals'])}>
                    <div className={'flex-1 flex-middle flex'}>
                        <BundleDealsTag className={styles.tag} />
                        <ReplaceAllText data={description} />
                    </div>

                    <div>
                        <Iconfont className={'icon-arrow-right'}/>
                    </div>

                </div>
            </a>
        </Link>
    );
};

export default observer(ProdBundleDeals)